export default "__VITE_ASSET__764fb052__"